import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Toast from '../toast';
import './index.scss';
import 'moment/locale/es';
import { saveTurn, updateStatus } from '../../redux/actions/turnActions';
import { MY_TURN_PATH } from '../../routes/path';

const CardConfirm = () => {
  const {
    dateTurnSelected, hoursSelected, error,
    saveStatus
  } = useSelector((state) => state.turnReducer);
  const { healthInsurance } = useSelector((state) => state.healthInsuranceReducer);
  const { doctor } = useSelector((state) => state.doctorReducer);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const fecha = moment(dateTurnSelected.fecha).locale('es').format('dddd D [de] MMMM [de] YYYY');
  const hours = moment(hoursSelected.fecha_hora).locale('es').format('HH:mm');

  const navigate = useNavigate();
  const confirmTurn = () => {
    const turn = {
      turno_id: hoursSelected.id,
      obra_social_id: healthInsurance.id
    };
    dispatch(saveTurn(turn));
  };

  useEffect(() => {
    if (saveStatus) {
      dispatch(updateStatus());
      navigate(MY_TURN_PATH);
    }
  }, [saveStatus]);

  return (
    <div
      className="container-confirm"
    >
      <Toast error={error} />
      <div className="info">
        <div className="datos1">
          <div className="doctor">
            <h5 className="subtitle">Médico</h5>
            <div className="container-doctor">
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}${doctor.foto_sm_url}`}
                alt={`Dr. ${doctor.nombre} ${doctor.apellido}`}
                className="cardConfirmImg-doctor"
              />
              <div className="cardConfirm-specialty">
                <p className="doctorConfirm-name">{`Dr. ${doctor.nombre} ${doctor.apellido}`}</p>
                <p className="doctor-specialty">{doctor.especialidad}</p>
              </div>
            </div>
          </div>

          <div className="your-datesMobile">
            <h3 className="your-dates">Sus datos</h3>
            <p>

              {user?.apellido}
              ,
              { user?.nombre}

            </p>
            <p>{user?.dni}</p>
            <p>{user?.email}</p>
            <p>{user?.telefono}</p>
          </div>
        </div>
        <div className="datos1">
          <div className="turn-datesMobile">
            <h3 className="turn-dates">Turno</h3>
            <p>{fecha}</p>
            <p>{hours}</p>
          </div>
          <div className="healt-datesMobile">
            <h3 className="healt-dates">Obra Social</h3>
            <p>{healthInsurance.nombre}</p>
          </div>
        </div>
      </div>
      <div className="button-box">
        <button onClick={confirmTurn} className="buttonConfirm-turn-confirm">Confirmar turno</button>
      </div>
    </div>
  );
};

export default CardConfirm;
